import {
    ADD_CHATEVENT,
    UPDATE_CHATEVENT,
    MARK_ALL_READ,
    SET_REGISTRATION,
    CHAT_RESET,
    SET_AGENT,
    SET_AGENTTYPING,
    SET_SESSIONACTIVE,
    SET_CHATSTATE,
    SET_MESSAGEINPUT,
    SHOW_OPTIONS,
    SET_FILE_LIMITS,
    SET_OFF_TOPIC,
    SET_MONITOR_FOR_USER_MO_LOGIN,
    SET_INPUT_MASK,
    REPORT_ERROR
} from '../../../helpers/action-types';
import { CHAT_STATE } from './actions';
import { CHAT } from './types';

const initialState = {
    messages: [],
    errors: [],
    registration: { registered: false },
    agent: { available: false, joined: false, name: null, typing: false },
    agentTyping: false,
    sessionActive: false,
    state: CHAT_STATE.NOT_STARTED,
    mode: null,
    submode: null,
    messageInput: null,
    options: null,
    isOffTopic: false,
    monitorForUserMOLogin: false,
    inputMask: '',
    fileLimits: {
        'delete-file': 'odd',
        'download-attempts': '0',
        'upload-file-types': '',
        'upload-max-file-size': '0',
        'upload-max-files': '0',
        'upload-max-total-size': '0',
        'used-download-attempts': '0',
        'used-upload-max-files': '0',
        'used-upload-max-total-size': '0'
    }
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case ADD_CHATEVENT:
            // avoid empty events
            if (action.message === null || action.message === undefined) {
                return state;
            }

            // avoid duplicates (NOR-82905, NOR-82913), we check for duplicate id (index from genesys)
            if (
                state.messages.filter((m) => {
                    return (
                        m.id !== undefined &&
                        m.id !== null &&
                        action.message.id !== undefined &&
                        action.message.id !== null &&
                        m.id === action.message.id &&
                        m.id !== -1 &&
                        m.id !== -2
                    );
                }).length > 0
            ) {
                return state;
            }

            return {
                ...state,
                messages: [
                    ...state.messages,
                    {
                        ...action.message,
                        isRead: false
                    }
                ]
            };

        case UPDATE_CHATEVENT:
            return {
                ...state,
                messages: state.messages.map((m) => {
                    return m.id !== undefined &&
                        m.id !== null &&
                        action.message.id !== undefined &&
                        action.message.id !== null &&
                        m.id === action.message.id
                        ? { ...m, ...action.message }
                        : m;
                })
            };

        case REPORT_ERROR:
            return {
                ...state,
                errors: [
                    ...state.errors,
                    {
                        ...action.error
                    }
                ]
            };

        case MARK_ALL_READ:
            return {
                ...state,
                messages: state.messages.map((m) => {
                    return {
                        ...m,
                        isRead: true
                    };
                })
            };

        case CHAT_RESET:
            return initialState;

        case SET_REGISTRATION:
            return {
                ...state,
                registration: {
                    ...state.registration,
                    ...action.registration
                }
            };

        case SET_MESSAGEINPUT:
            return {
                ...state,
                messageInput: action.messageInput
            };

        case SET_AGENT:
            return {
                ...state,
                agent: {
                    ...state.agent,
                    available: action.available,
                    joined: state.agent.joined || action.available,
                    name: action.name === undefined ? state.agent.name : action.name // if undefined, leave last agent name
                }
            };

        case SET_AGENTTYPING:
            return {
                ...state,
                agentTyping: action.agentTyping || false
            };

        case SET_SESSIONACTIVE:
            return {
                ...state,
                sessionActive: action.sessionActive
            };

        case SET_CHATSTATE:
            return {
                ...state,
                state: action.state
            };

        case SHOW_OPTIONS:
            return {
                ...state,
                options: action.options
            };

        case SET_FILE_LIMITS:
            return {
                ...state,
                fileLimits: action.fileLimits
            };

        case CHAT.SET_API_MODE:
            return {
                ...state,
                mode: action.mode
            };

        case CHAT.SET_API_SUBMODE:
            return {
                ...state,
                submode: action.submode
            };

        case SET_OFF_TOPIC:
            return {
                ...state,
                isOffTopic: action.isOffTopic
            };

        case SET_MONITOR_FOR_USER_MO_LOGIN:
            return {
                ...state,
                monitorForUserMOLogin: action.doMonitor
            };

        case SET_INPUT_MASK:
            return {
                ...state,
                inputMask: action.mask
            };

        default:
            return state;
    }
};

export default reducer;
